import React, {useEffect, useState} from "react";
import logo from "../../resource/7.png";
import CommonFormFields from "./CommonFormFields";
import Swal from "sweetalert2";
import axios from "axios";
import apiClient from "@/api/client";

const ExternalRetreatGlen = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobileNumber: "",
    wtNumber: "",
    email: "",
    number_of_people: "",
    ip_address: "",
  });

  const [loading, setLoading] = useState(false); // Loading state
  const [errors, setErrors] = useState({}); // Error state


  useEffect(() => {
    const fetchIP = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setFormData((prevFormData) => ({
          ...prevFormData,
          ip_address: response.data.ip, // Set the IP address
        }));
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    fetchIP();
  }, []);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: checked,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  // Validate form fields
  const validateForm = () => {
    const newErrors = {};

    // Validate First Name
    if (!formData.firstName) newErrors.firstName = "First Name is required";
    else if (!/^[A-Za-z\s\-]+$/.test(formData.firstName))
      newErrors.firstName = "First Name should contain only letters, spaces, or hyphens";

    // Validate Last Name
    if (!formData.lastName) newErrors.lastName = "Last Name is required";
    else if (!/^[A-Za-z\s\-]+$/.test(formData.lastName))
      newErrors.lastName = "Last Name should contain only letters, spaces, or hyphens";

    // Validate Mobile Number
    if (!formData.mobileNumber) newErrors.mobileNumber = "Mobile Number is required";
    else if (!/^\d{10}$/.test(formData.mobileNumber))
      newErrors.mobileNumber = "Mobile Number should be 10 digits";

    // Validate Email
    if (!formData.email) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Invalid email format";

    // Validate WhatsApp Number
    if (!formData.wtNumber) newErrors.wtNumber = "WhatsApp Number is required";
    else if (!/^\d{10}$/.test(formData.wtNumber))
      newErrors.wtNumber = "WhatsApp Number should be 10 digits";

    // Validate Number of People
    if (!formData.number_of_people) newErrors.number_of_people = "Number of people is required";
    else if (!/^\d+$/.test(formData.number_of_people))
      newErrors.number_of_people = "Number of people should be a valid number";

    setErrors(newErrors); // Set errors
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form
    if (!validateForm()) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please check the form for errors.",
      });
      return; // Stop execution if validation fails
    }

    setLoading(true); // Set loading state

    try {
      // Submit form data to API
      const response = await apiClient.post('/external_retreat_request_form_glen_waverley-request',
          formData
      );

      console.log("Form submitted successfully:", response.data);

      // Show success message
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Form submitted successfully!",
      });

      // Reset form
      setFormData({
        firstName: "",
        lastName: "",
        mobileNumber: "",
        wtNumber: "",
        email: "",
        number_of_people: "",
        ip_address: "",
      });
    } catch (error) {
      console.error("Error submitting form:", error);

      // Handle API errors
      let errorMessage = "Something went wrong!";
      if (error.response) {
        errorMessage = error.response.data.message || "An error occurred while submitting the form.";
      } else if (error.request) {
        errorMessage = "No response from the server. Please try again later.";
      }

      // Show error message
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: errorMessage,
      });
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  return (
      <div className="form-page dark-gold ">
        <form onSubmit={handleSubmit}>
          <div className="form-title">
            <img src={logo} alt="" width={200} />
            <div className="details">
              <h1 className="font-second">Bhaddeka Vihari Monastery Center</h1>
              <h2 className="h4">External Retreat Request Form – Glen Waverley</h2>
            </div>
          </div>

          <p className="font-p mt-6">
            Please fill in the following details and we will contact you.
          </p>

          {/* Common form fields */}
          <CommonFormFields
              formData={formData}
              handleInputChange={handleInputChange}
              errors={errors}
          />

          <p className="font-p mt-5">
            Please indicate number of people interested attending the meditation retreat.
          </p>

          {/* Number of people input field */}
          <div className="form-box mt-5">
            <div className="form-item">
              <input
                  type="text"
                  id="number_of_people"
                  name="number_of_people"
                  value={formData.number_of_people}
                  onChange={handleInputChange}
              />
              <label htmlFor="number_of_people"></label>
              {errors.number_of_people && (
                  <span className="error">{errors.number_of_people}</span>
              )}
            </div>
          </div>

          {/* Submit button */}
          <button type="submit" id="submitbtn" className="mt-5" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>

          <p className="font-p mt-5 pb-4">
            We appreciate your interest in participation of the meditation retreat. We will be in touch with you shortly.
          </p>
        </form>
      </div>
  );
};

export default ExternalRetreatGlen;